import app from 'flarum/forum/app';
import YandexMetrikaLoader from './service/YandexMetrikaLoader';
import YandexMetrikaNavigationTracker from './service/YandexMetrikaNavigationTracker';
app.initializers.add('devconnect-seo-yandex-metrika', () => {
  app.beforeMount(() => {
    if (app.forum.attribute('devconnectYandexMetrikaEnabled') === false) return;
    const loader = new YandexMetrikaLoader(window, document, app.forum.attribute('devconnectYandexMetrikaId'), app.forum.attribute('devconnectLegalCookieVersion') || '2026-08-08');
    const navigationTracker = new YandexMetrikaNavigationTracker(window, document, app.forum.attribute('devconnectYandexMetrikaId'));

    // Первый запуск сработает только при ранее сохранённом актуальном согласии.
    loader.start();
    navigationTracker.start();

    // Новое согласие включает Метрику без перезагрузки и без повторной инициализации счётчика.
    window.addEventListener('devconnect:cookie-consent-changed', event => {
      if (event.detail?.preference === 'analytics') {
        loader.start();
      }
    });
  });
});